import React, { Suspense } from 'react';
import { checkIsObjectEmpty } from '../../../../../utils/common/dataTypes/object.js';

var Poll = React.lazy(function () { return import('./Poll.js'); });
var LazyLoadedPoll = function (props) {
    var showPoll = props.showPoll, pollData = props.pollData, votingDisabled = props.votingDisabled, onClickVotes = props.onClickVotes, callCastVote = props.callCastVote, errorLogger = props.errorLogger, notifyError = props.notifyError;
    if (!showPoll || !pollData || checkIsObjectEmpty(pollData))
        return null;
    return (React.createElement(Suspense, { fallback: null },
        React.createElement(Poll, { data: pollData, votingDisabled: votingDisabled, errorLogger: errorLogger, notifyError: notifyError, callCastVote: callCastVote, onClickVotes: onClickVotes })));
};

export { LazyLoadedPoll };
//# sourceMappingURL=LazyLoadedPoll.js.map
